angular.module("admin").factory("AdminExportTemplatesService", ["$rootScope", "$http", "ENV", function ($rootScope, $http, ENV) {

	const TEMPLATES_URL = ENV.API_URL + "/admin/export-templates";
	const vm = {
		get: (id) => $http.get(TEMPLATES_URL + "/" + id),
		getAll: () => $http.get(TEMPLATES_URL + "?mobiiti_lines=false&no_line=true"),
		getAllByTemplateId: (id) => $http.get(TEMPLATES_URL + "/" + id + "/global-export-monitoring"),
		getAllWithMosaicLines: () => $http.get(TEMPLATES_URL + "?mobiiti_lines=true"),
		save: (entity) => !entity.id ? vm.add(entity) : vm.update(entity),
		add: (exportTemplate) => $http.post(TEMPLATES_URL, exportTemplate),
		update: (exportTemplate) => $http.put(TEMPLATES_URL + "/" + exportTemplate.id, exportTemplate),
		delete: (id) => $http.delete(TEMPLATES_URL + "/" + id),
		getCron: (exportConfigurationId, providerId) => $http.get(`${ENV.TIMETABLE_ADMIN_BASE_URL}${providerId}/predefinedExport/netexFares/${exportConfigurationId}/schedule`),
		updateCron: (exportConfigurationId, providerId, cronExpression) => $http.post(`${ENV.TIMETABLE_ADMIN_BASE_URL}${providerId}/predefinedExport/netexFares/${exportConfigurationId}/schedule`, {}, {
			headers: {
				"CronExpression": cronExpression
			}
		}),
		deleteCron: (exportConfigurationId, providerId) => $http.delete(`${ENV.TIMETABLE_ADMIN_BASE_URL}${providerId}/predefinedExport/netexFares/${exportConfigurationId}/schedule`)
	};

	return vm;

}]);